import { Grid } from '@mui/material'
import { AbsenceOccurrence } from '../../../../../../types/absence'
import Paragraph from '../../../../../../shared/UI/Paragraph'
import { getLocalDateString } from '../../../../../../utils/date-utils'
import { calculateTotalHoursLost, calculateTotalSickPayHours } from '../../../../../../utils/rtwUtils'

type Props = {
  absenceData: AbsenceOccurrence
}

function AbsenceInfoSection({ absenceData }: Props) {
  return (
    <Grid item xs={12} lg={6} display="flex">
      <Grid container xl={12} alignContent="flex-start">
        {/* Date of Absence */}
        <Grid item xs={12} display="flex" mt={4}>
          <Paragraph weight="bold" padding="0 0 5px 0">
            Date of Absence
          </Paragraph>
        </Grid>
        <Grid item xs={12}>
          <Paragraph>
            {getLocalDateString(absenceData.startDate)}
            {' - '}
            {getLocalDateString(absenceData.endDate)}
          </Paragraph>
        </Grid>

        {/* Total Hours Lost */}
        <Grid item xs={12} mt={4}>
          <Paragraph weight="bold" padding="0 0 5px 0">
            Total hours absent
          </Paragraph>
        </Grid>
        <Grid item xs={12}>
          <Paragraph>
            {calculateTotalHoursLost(absenceData.absenceDays)}
          </Paragraph>
        </Grid>

        {/* Total number of sick pay hours used */}
        <Grid item xs={12} mt={4}>
          <Paragraph weight="bold" padding="0 0 5px 0">
            Total number of sick pay hours used
          </Paragraph>
        </Grid>
        <Grid item xs={12}>
          <Paragraph>
            {calculateTotalSickPayHours(absenceData.absenceDays)}
          </Paragraph>
        </Grid>

        {/* Absence Classification */}
        <Grid item xs={12} display="flex" mt={4}>
          <Paragraph weight="bold" padding="0 0 5px 0">
            Absence Classification
          </Paragraph>
        </Grid>
        <Grid item xs={12}>
          <Paragraph>{absenceData.absenceDays[0].absenceType.reasonTypeDescription}</Paragraph>
        </Grid>

        {/* Absence Reason */}
        <Grid item xs={12} mt={4}>
          <Paragraph weight="bold" padding="0 0 5px 0">
            Absence Reason
          </Paragraph>
        </Grid>
        <Grid item xs={12}>
          <Paragraph>{absenceData.reason}</Paragraph>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default AbsenceInfoSection